import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!-- @glint-nocheck: this template is not typesafe yet --}}\n<div class=\"embercom-prosemirror-composer-imagetext-inserter-header p-2 text-center\">\n  <Heading @size=\"4\">\n    {{yield}}\n  </Heading>\n</div>", {
  moduleName: "@intercom/composer-ember/components/tools/image-text/header.hbs"
});